import _ from "lodash";
import PropTypes from "prop-types";
import React, { Fragment, useContext } from "react";
import { createUseStyles } from "react-jss";
import { StyleTypeContext, TranslationContext } from "../../umbilical_tools";
import tourIconMobileType2 from "../icons/tourIconMobileType2.svg";
import pkgIconMobileType2 from "./../icons/pkgIconMobileType2.svg";
import { Button } from "./Button";
import jssVariables from "../../jss_setup";
import { Price } from "./Price";

const bottomContainerStyles = createUseStyles({
  bottomContainer: (props) => ({
    display: "grid",
    gridTemplateColumns: "max-content max-content",
    alignItems: "center",
    padding: `calc(${jssVariables.normal_gap} * 1.5) ${jssVariables.double_gap}`,
    justifyContent: "space-between",
    ..._.get(props, "customStyles.bottomContainer", {}),
  }),
  priceContainer: (props) => ({
    justifySelf: "end",
    display: "grid",
    gridGap: `calc(${jssVariables.normal_gap} / 2)`,
    justifyItems: "center",
    alignContent: "end",
    "& span": {
      whiteSpace: "nowrap",
      textOverflow: "ellipsis",
      overflow: "hidden",
      width: "100%",
    },
    ..._.get(props, "customStyles.priceContainer", {}),
  }),
  priceTxt: (props) => ({
    color: jssVariables.colors.base_color,
    ..._.get(props, "customStyles.priceTxt", {}),
  }),
  priceValue: (props) => ({
    color: jssVariables.colors.text.dark,
    fontSize: "x-large",
    ..._.get(props, "customStyles.priceValue", {}),
  }),
  btnContainer: (props) => ({
    ..._.get(props, "customStyles.btnContainer", {}),
  }),
  image: (props) => ({
    ..._.get(props, "customStyles.image", {}),
  }),
  capitalize: (props) => ({
    textTransform: "capitalize",
    ..._.get(props, "customStyles.capitalize", {}),
  }),
  linkIconTmdh: (props) => ({
    ..._.get(props, "customStyles.linkIconTmdh", {}),
  }),
  [`@media ${jssVariables.media.smallscreen}`]: {
    bottomContainer: (props) => ({
      ..._.get(props, "customStyles.bottomContainer.smallscreen", {}),
    }),
    priceContainer: (props) => ({
      ..._.get(props, "customStyles.priceContainer.smallscreen", {}),
    }),
    priceValue: (props) => ({
      ..._.get(props, "customStyles.priceValue.smallscreen", {}),
    }),
    btnContainer: (props) => ({
      ..._.get(props, "customStyles.btnContainer.smallscreen", {}),
    }),
    linkIconTmdh: (props) => ({
      width: `calc(${jssVariables.normal_gap} * 2.5)`,
      ..._.get(props, "customStyles.linkIconTmdh.smallscreen", {}),
    }),
  },
  [`@media ${jssVariables.media.bigscreen}`]: {
    bottomContainer: (props) => ({
      ..._.get(props, "customStyles.bottomContainer.bigscreen", {}),
    }),
    priceValue: (props) => ({
      ..._.get(props, "customStyles.priceValue.bigscreen", {}),
    }),
  },
});
const BottomContainer = (props) => {
  const {
    id,
    min_price,
    currency,
    customStyles,
    booking_mode,
    handleBookNow,
    isPkg,
    redirectLink,
  } = props;
  const classes = bottomContainerStyles({ customStyles });
  const { brand } = useContext(StyleTypeContext);
  const { t } = useContext(TranslationContext);

  return (
    <div className={classes.bottomContainer}>
      <div className={classes.priceContainer}>
        {booking_mode === "CO" ? (
          <span className={classes.priceTxt}>
            <span className={classes.capitalize}>{`${t("from")} `}</span>
            <span className={classes.priceValue}>
              <Price price={min_price} currency={currency} styleless />
            </span>
          </span>
        ) : (
          <span className={classes.priceTxt}>{t("onRequest")}</span>
        )}
      </div>
      <span
        className={classes.btnContainer}
        id={id}
        onClick={() => (redirectLink ? (window.location.href = redirectLink) : handleBookNow())}
      >
        <Button
          size="medium"
          icon="icons8:angle-right"
          text={t("view")}
          showIcon={true}
          customStyles={_.get(customStyles, "viewBtnStyles", {})}
        />
      </span>
    </div>
  );
};
BottomContainer.defaultProps = {
  min_price: 0,
  currency: "EUR",
  customStyles: {},
  booking_mode: "",
  isPkg: false,
  redirectLink: "",
  id: "",
};
BottomContainer.propTypes = {
  min_price: PropTypes.number,
  currency: PropTypes.string,
  booking_mode: PropTypes.string,
  customStyles: PropTypes.object.isRequired,
  handleBookNow: PropTypes.func.isRequired,
  isPkg: PropTypes.bool,
  redirectLink: PropTypes.string,
  id: PropTypes.string,
};

export default BottomContainer;
